class FlowList {
    constructor(element) {
        this.element = element
        this.listItems = [...this.element.querySelectorAll('.flow__item')]
        this.firstElementRect = this.listItems[0].getBoundingClientRect()
        this.init()
    }

    init() {
        this.evaluateActiveItem()
        this.setScrollLevelHeight()

        window.addEventListener('scroll', () => this.evaluateActiveItem(), { passive: true })
    }

    setScrollLevelHeight() {
        if (this.firstElementRect) {
            this.element.style.setProperty('--flow-scroll-level-height', `${this.firstElementRect.height}px`)
        }
    }

    evaluateActiveItem() {
        const viewportCenterY = window.innerHeight / 2

        let smallestDistance = Infinity
        let closestElement = null

        this.listItems.forEach(element => {
            const rect = element.getBoundingClientRect()
            const elementCenterY = rect.top + rect.height / 2
            const distance = Math.abs(elementCenterY - viewportCenterY)

            // get the closest element
            if (distance < smallestDistance) {
                smallestDistance = distance
                closestElement = element
            }
        })

        // update the active class for all items 
        this.listItems.map(item => this.toggleActive(item, closestElement === item))

    }

    toggleActive(el, force) {
        el.classList.toggle('flow__item--active', force)
    }

}

export default FlowList